module.exports = __webpack_public_path__ + "media/assets/img/products/studio_manual-selected-590f7c438ba010584da4d584026954c7.svg";